var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", [
      _c("h1", {
        staticClass: "title is-3 print-no-vertical",
        domProps: { textContent: _vm._s(_vm.meeting.name) }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "subtitle is-6" }, [
        _vm._m(0),
        _vm._v(
          _vm._s(
            _vm.formatTime(_vm.meeting.start_date) +
              " - " +
              _vm.formatTime(_vm.meeting.end_date)
          ) + "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "columns mt-4" },
      [
        _c("div", { staticClass: "column is-one-quarter is-hidden-print" }, [
          _c("nav", { staticClass: "menu" }, [
            _c("ul", { staticClass: "menu-list" }, [
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "UserSuites",
                          params: { id: _vm.meeting.id }
                        },
                        exact: ""
                      }
                    },
                    [_vm._v("View Your Schedule")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.writeableSuites.length && _vm.meeting.phase_index === 2
              ? _c("ul", { staticClass: "menu-list" }, [
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "ViewExhibitors" } } },
                        [_vm._v("Schedule an Appointment")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.writeableSuites.length
              ? _c("p", { staticClass: "menu-label" }, [
                  _vm._v("Manage Suites")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.writeableSuites.length
              ? _c(
                  "ul",
                  { staticClass: "menu-list" },
                  _vm._l(_vm.sortedSuiteKeys, function(key, idx) {
                    return _vm.isSuiteWriteable(key)
                      ? _c("li", { key: idx }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.clickEditSuite(key)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.suites[key].name))]
                          )
                        ])
                      : _vm._e()
                  }),
                  0
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          _c("main", { staticClass: "main" }, [_c("router-view")], 1)
        ]),
        _vm._v(" "),
        _vm.showingModal
          ? _c(
              "modal",
              {
                attrs: { title: "Edit Suite", width: "800px" },
                on: {
                  close: function($event) {
                    _vm.showingModal = false
                  }
                }
              },
              [
                _c("edit-suite", {
                  attrs: { suite: _vm.selectedSuite, isAdmin: false }
                }),
                _vm._v(" "),
                _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-success",
                      class: { "is-loading": _vm.loading },
                      on: { click: _vm.saveSuite }
                    },
                    [_vm._v("\n          Save\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function($event) {
                          _vm.showingModal = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                ])
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-calendar-alt" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bfbf1fa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bfbf1fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AttendeeDashboard.vue
// module id = null
// module chunks = 